// import { createApp } from 'vue'
// import App from './App.vue'
// import './index.css'
// import router from './router'
// import store from './store'
// import ElementPlus from 'element-plus'
// import 'element-plus/lib/theme-chalk/index.css'
// import "./assets/css/global.css"
// import { ElMessage } from "element-plus"
// import VueCookies from 'vue-cookies'
// const app = createApp(App)
// app.use(router)
// app.use(store)
//
// // if(process.env.NODE_ENV == "development"){
// //  调试模式
//     VueCookies.set("username", "温必乐")
//     VueCookies.set("token", "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoiODkwMzAxODQzODAyOTQ3NTg0IiwiaWF0IjoxNjMyMzcyMTY2Ljk5MjU1NjMsImV4cCI6MTYzMjM3OTM2Ni45OTI1NTYzfQ.1UuSDxJtihshc4cOjSKnUs7bDmUzTUnTujtPPQE0-Q0")
//     VueCookies.set("userid", "890301843802947584")
// // }
//
// app.use(ElementPlus)
// // app.use(ElTable)
// app.provide("$message", ElMessage)
// app.config.globalProperties.$cookies = VueCookies
// app.mount('#app')


import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueCookies from 'vue-cookies'
Vue.use(VueCookies)
Vue.config.productionTip = false

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import "./assets/css/global.css"
import './index.css'


if(process.env.NODE_ENV == "development"||store.state.debugMode){
 // console.log('debug调试模式')
 // 调试模式
    VueCookies.set("username", "戚绮琦")
    VueCookies.set("token", "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2lkIjoiODcwMzk2ODcwNDg3MTc5MjY0IiwiaWF0IjoxNjU0NTE1MjMyLjM5NjQwOCwiZXhwIjoxNjU0NTIyNDMyLjM5NjQwOH0.xlXvV8OBkrykus81WzJ0IflBn7NW2ej73xHN8A5pPuc")
    VueCookies.set("userid", "105477603529326592")
}

Vue.use(ElementUI);

import {Loading,Message} from "element-ui";
Vue.use(Loading.directive);
Vue.prototype.$loading = Loading;
Vue.prototype.$message = Message;


import plTable from 'pl-table'
import 'pl-table/themes/index.css'
require('./utils/util')
Vue.use(plTable);


// import UmyUi from 'umy-ui'
// import 'umy-ui/lib/theme-chalk/index.css';// 引入样式
// Vue.use(UmyUi);


// import ElBigdataTable from "vue-element-bigdata-table"
//
// Vue.use(ElBigdataTable)


new Vue({
    router,
    store,
    beforeCreate(){
        Vue.prototype.$bus = this
    },
    render: h => h(App)
}).$mount('#app')

// var Ctor = Vue.extend(App)
// new Ctor().$mount('#app')